import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  ASSET_TYPE_LIST, ASSET_TYPE_DATA, ASSET_TYPE_CREATE,
  ASSET_TYPE_UPDATE, ASSET_TYPE_DELETE,
} from "./actionType";
import {
  assetTypeListSuccess, assetTypeListFailure,
  assetTypeDataSuccess, assetTypeDataFailure,
  assetTypeCreateSuccess, assetTypeCreateFailure,
  assetTypeUpdateSuccess, assetTypeUpdateFailure,
  assetTypeDeleteSuccess, assetTypeDeleteFailure,
} from "./action";
import {
  assetTypeListApi, assetTypeDataApi, assetTypeCreateApi,
  assetTypeUpdateApi, assetTypeDeleteApi,
} from "../../helpers/fakebackend_helper";

function* handleList() {
  try { yield put(assetTypeListSuccess(yield call(assetTypeListApi))); }
  catch (e) { yield put(assetTypeListFailure(e)); }
}
function* handleData({ payload }) {
  try { yield put(assetTypeDataSuccess(yield call(assetTypeDataApi, payload))); }
  catch (e) { yield put(assetTypeDataFailure(e)); }
}
function* handleCreate({ payload }) {
  try { yield put(assetTypeCreateSuccess(yield call(assetTypeCreateApi, payload))); }
  catch (e) { yield put(assetTypeCreateFailure(e)); }
}
function* handleUpdate({ payload }) {
  try { yield put(assetTypeUpdateSuccess(yield call(assetTypeUpdateApi, payload))); }
  catch (e) { yield put(assetTypeUpdateFailure(e)); }
}
function* handleDelete({ payload }) {
  try { yield put(assetTypeDeleteSuccess(yield call(assetTypeDeleteApi, payload))); }
  catch (e) { yield put(assetTypeDeleteFailure(e)); }
}

export default function* AssetTypeSaga() {
  yield all([
    fork(function* () { yield takeEvery(ASSET_TYPE_LIST,   handleList);   }),
    fork(function* () { yield takeEvery(ASSET_TYPE_DATA,   handleData);   }),
    fork(function* () { yield takeEvery(ASSET_TYPE_CREATE, handleCreate); }),
    fork(function* () { yield takeEvery(ASSET_TYPE_UPDATE, handleUpdate); }),
    fork(function* () { yield takeEvery(ASSET_TYPE_DELETE, handleDelete); }),
  ]);
}
